import { Alert } from "@mui/material";
import { LoadingIndicator } from "src/components/general/LoadingIndicator/LoadingIndicator";
import SystemSettingsTokenManagementTable from "./components/SystemSettingsTokenManagementTable/SystemSettingsTokenManagementTable";
import SystemSettingsTokenManagementToolbar from "./components/SystemSettingsTokenManagementToolbar/SystemSettingsTokenManagementToolbar";
import { READ_ONLY_TOKENS_MESSAGE } from "./SystemSettingsTokenManagement.constants";
import { useSystemSettingsTokenManagement } from "./SystemSettingsTokenManagement.hooks";

export default function SystemSettingsTokenManagement() {
  const {
    isReadOnly,
    tokens,
    isLoading,
    isError,
    revokedTokens,
    displayedTokens,
    showRevoked,
    setShowRevoked,
    menuAnchor,
    handleMenuClose,
    handleRevoke,
    handleReactivate,
    handleDelete,
    openMenu,
  } = useSystemSettingsTokenManagement();

  if (isReadOnly) {
    return (
      <Alert severity="info" data-test-id="token-management-read-only">
        {READ_ONLY_TOKENS_MESSAGE}
      </Alert>
    );
  }

  if (isLoading) return <LoadingIndicator loading />;

  if (isError) {
    return (
      <Alert severity="error">Failed to load tokens. Please try again later.</Alert>
    );
  }

  return (
    <div
      className="flex flex-col gap-4"
      data-test-id="system-settings-token-management"
    >
      <SystemSettingsTokenManagementToolbar
        revokedCount={revokedTokens.length}
        showRevoked={showRevoked}
        onShowRevokedChange={setShowRevoked}
      />

      {!tokens?.length ? (
        <p className="py-4 text-center text-sm text-text-secondary">
          No tokens found.
        </p>
      ) : (
        <SystemSettingsTokenManagementTable
          displayedTokens={displayedTokens}
          menuAnchor={menuAnchor}
          onOpenMenu={openMenu}
          onMenuClose={handleMenuClose}
          onRevoke={handleRevoke}
          onReactivate={handleReactivate}
          onDelete={handleDelete}
        />
      )}
    </div>
  );
}
